import React from "react";
import { Link, useParams } from "react-router-dom";

import Header from "../../components/header";
import SeoHead from "../../components/seoHead";
import ProductInformation from "../productInformation";
import { getTcgRouteItem } from "./routeMap";

export default function TcgLandingPage() {
  const { brand, slug } = useParams<{ brand: string; slug: string }>();
  const routeItem = getTcgRouteItem(brand, slug);
  const routePath = `/${[brand, slug].filter(Boolean).join("/")}`;

  if (!routeItem) {
    return (
      <>
        <SeoHead
          title="Page Not Found"
          description="This brand/slug route does not map to any product content."
          path={routePath}
          noindex
        />
        <Header />
        <div className="min-h-screen bg-slate-900 text-slate-300 flex flex-col items-center justify-center gap-4 px-6">
          <h1 className="text-3xl font-bold text-white">no page found</h1>
          <p className="text-slate-400 text-center max-w-md">
            This brand/slug does not have a corresponding content, please check
            if the URL is correct.
          </p>
          <Link to="/" className="text-red-300 hover:text-red-200 underline">
            Back to home
          </Link>
        </div>
      </>
    );
  }

  return (
    <ProductInformation
      forcedProductSlug={routeItem.productSlug}
      canonicalPath={`/${routeItem.brand}/${routeItem.slug}`}
    />
  );
}
